var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSs2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12455_25575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.799805 36H23.1998V39.2H0.799805V36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 32.7738C20 32.3495 19.8314 31.9425 19.5314 31.6425C19.2313 31.3424 18.8243 31.1738 18.4 31.1738H5.6C5.17565 31.1738 4.76869 31.3424 4.46863 31.6425C4.16857 31.9425 4 32.3495 4 32.7738V34.3998H20V32.7738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5704 19.6922C21.8249 20.4868 21.1998 21.3862 20.7148 22.3618L33.8844 35.5314C34.1845 35.8314 34.5914 35.9999 35.0156 35.9999C35.4399 35.9999 35.8468 35.8314 36.1468 35.5314L38.4096 33.2686C38.5582 33.1201 38.6761 32.9437 38.7565 32.7496C38.8369 32.5554 38.8783 32.3474 38.8783 32.1372C38.8783 31.9271 38.8369 31.7191 38.7565 31.5249C38.6761 31.3308 38.5582 31.1544 38.4096 31.0058L25.24 17.8398C24.2627 18.3205 23.3628 18.9449 22.5704 19.6922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6506 11.7734C13.4407 12.8963 12.0401 13.7942 10.5146 14.425L18.7842 22.6946C19.4207 21.1718 20.3195 19.7726 21.4398 18.5606C22.6499 17.4378 24.0505 16.5398 25.5758 15.9086L17.3058 7.64062C16.6692 9.16285 15.7705 10.5616 14.6506 11.7734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3047 1.59273L18.0423 3.85513C17.4176 4.47987 17.4176 5.49278 18.0423 6.11753L27.0919 15.1671C27.7167 15.7919 28.7296 15.7919 29.3543 15.1671L31.6167 12.9047C32.2415 12.28 32.2415 11.2671 31.6167 10.6423L22.5671 1.59273C21.9424 0.967984 20.9295 0.967984 20.3047 1.59273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72856 15.1669L4.46616 17.4293C3.84142 18.0541 3.84142 19.067 4.46616 19.6917L13.5158 28.7413C14.1405 29.3661 15.1534 29.3661 15.7782 28.7413L18.0406 26.4789C18.6653 25.8542 18.6653 24.8413 18.0406 24.2165L8.99096 15.1669C8.36622 14.5422 7.35331 14.5422 6.72856 15.1669Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12455_25575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.4,
    height: 38.4,
    fill: "white",
    transform: "translate(0.799805 0.800781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSs2);
export default __webpack_public_path__ + "static/media/ss2.e51aa9b15f26882101d2c8b9839d56f4.svg";
export { ForwardRef as ReactComponent };